import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [followed, setFollowed] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 items-center gap-4 px-4 md:px-6 max-w-[1400px]">
        <a href="#top" className="flex items-center gap-3 whitespace-nowrap">
          <span className="relative flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-flashlight-fill text-lg" />
          </span>
          <span className="leading-tight">
            <span className="block font-heading text-base font-bold text-foreground-950">快手黑料</span>
            <span className="block text-[11px] text-foreground-600">辟谣 · 反转 · 进展追踪</span>
          </span>
        </a>

        <nav className="ml-6 hidden flex-1 items-center gap-1 lg:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm text-foreground-700 transition hover:text-foreground-950 hover:bg-background-100"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-3 md:flex">
          <div className="hidden h-9 w-56 items-center gap-2 rounded-full border border-background-300/60 bg-background-100/60 px-3 lg:flex">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              placeholder="搜索事件 / 关键词"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
            />
          </div>
          <button
            type="button"
            onClick={() => setFollowed((v) => !v)}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition ${
              followed
                ? "bg-background-100 text-foreground-500 border border-background-300/60"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className={`${followed ? "ri-check-line" : "ri-add-line"} text-base`} />
            {followed ? "已关注" : "关注事件"}
          </button>
        </div>

        <button
          type="button"
          aria-label="菜单"
          onClick={() => setOpen((v) => !v)}
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300/60 text-foreground-900 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`} />
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 py-3 backdrop-blur lg:hidden">
          <div className="flex flex-wrap gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-full bg-background-100 px-3 py-1.5 text-sm text-foreground-800"
              >
                {l.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            onClick={() => setFollowed((v) => !v)}
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            <i className={`${followed ? "ri-check-line" : "ri-add-line"} text-base`} />
            {followed ? "已关注事件" : "关注事件动态"}
          </button>
        </div>
      )}
    </header>
  );
}